import {CALL_API} from 'middleware/api';

export const SIGNOUT = 'SIGNOUT';
export const SUCCESS_SIGNOUT = 'SUCCESS_SIGNOUT';
export const FAILURE_SIGNOUT = 'FAILURE_SIGNOUT';

function fetchSignout(data) {
    return {
        type: SIGNOUT,
        [CALL_API]: {
            endpoint: '/api/sign/out',
            method: 'post',
            types: [SUCCESS_SIGNOUT, FAILURE_SIGNOUT],
            credentials: true,
            data
        }
    };
}

export function signout(data) {
    return (dispatch) => {
        return dispatch(fetchSignout(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/SignoutAction.js